import type { BigIntish } from '@morpho-org/blue-sdk'

import { parseEther } from 'viem'

import { LTV_AT_RISK_OF_LIQUIDATION_THRESHOLD, LTV_WARNING_THRESHOLD } from '../constants'

/**
 * Determines if a position is unhealthy based on its LTV (Loan-to-Value) and LLTV (Liquidation LTV).
 *
 * @param ltv - The current Loan-to-Value ratio of the position
 * @param lltv - The Liquidation Loan-to-Value ratio of the position
 * @returns A boolean indicating whether the position is unhealthy (true) or healthy (false)
 */
export const getIsPositionUnhealthy = (ltv: BigIntish, lltv: BigIntish): boolean => {
  const ltvBigInt = BigInt(ltv)
  const lltvBigInt = BigInt(lltv)
  if (lltvBigInt === 0n) return false

  const healthRatio = (ltvBigInt * parseEther('1')) / lltvBigInt

  return healthRatio >= LTV_WARNING_THRESHOLD
}

/**
 * Determines if a position is at risk of liquidation based on its LTV (Loan-to-Value) and LLTV (Liquidation LTV).
 *
 * @param ltv - The current Loan-to-Value ratio of the position
 * @param lltv - The Liquidation Loan-to-Value ratio of the position
 * @returns A boolean indicating whether the position is at risk of liquidation (true) or not (false)
 */
export const getIsPositionAtRiskOfLiquidation = (ltv: bigint, lltv: bigint): boolean => {
  if (lltv === 0n) return false

  const healthRatio = (ltv * parseEther('1')) / lltv

  return healthRatio >= LTV_AT_RISK_OF_LIQUIDATION_THRESHOLD
}
